import * as React from "react";

interface DefaultSectionProps {
  children: React.ReactNode;
}

export const DefaultSection: React.FC<DefaultSectionProps> = ({ children }) => {
  return (
    <section className="tw-flex tw-w-full tw-flex-col tw-items-center tw-pb-[67px] max-sm:!tw-pb-[50px]">
      <div className="tw-flex tw-flex-col tw-items-center tw-pt-[111px] !tw-text-center max-lg:tw-pt-[24px] max-sm:!tw-h-auto max-sm:!tw-pb-0">
        <div className="tw-flex-col tw-items-center max-container:!tw-w-[83%] max-sm:!tw-w-[90%] min-container:!tw-w-[60%] min-lg:tw-flex">
          {children}
        </div>
      </div>
    </section>
  );
};
